import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from './actions';
import Radium from 'radium';
import { Scrollbars } from 'react-custom-scrollbars';
import Apvs from './spreadsheets/apvs'
import Modal from '../Common/modal';


import auth from '../Login/authService'

class APV extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hide: true,
        }
    }

    componentWillMount() {
        if (auth.getProfile().role === 'Formand') {
            throw new Error('Formand forsøgte at tilgå apv')
        } else {
            this.props.dispatch(actions.getApvs())
        }
    }

    openPdf = (document, type) => {
        if (!document.fileUrl.startsWith('http')) {
            if (type === 'click') {
                window.open("data:application/pdf;base64," + document.fileUrl)
            } else {
                this.setState({
                    hide: false,
                    document: { base64: "data:application/pdf;base64," + document.fileUrl }
                })
            }
        } else {
            this.setState({
                hide: false,
                document: { url: document.fileUrl }
            })
        }
    }

    save = (index) => {
        this.props.dispatch(actions.saveApv(index))
    }

    cancel = (index) => {
        this.props.dispatch(actions.cancel(index))
    }

    updateApv = (obj, index) => {
        this.props.dispatch(actions.updateApv(obj, index))
    }

    update = (key, value, index) => {
        this.props.dispatch(actions.update(key, value, index))
    }

    render() {
        return (
            <div style={styles.container}>
                <Modal
                    hide={this.state.hide}
                    onClose={() => {
                        this.setState({ hide: !this.state.hide })
                    }}
                >
                    {this.state.document ?
                        (this.state.document.base64 ?
                            <iframe
                                title="dpf1"
                                scrolling="no"
                                width="100%"
                                height="95%"
                                src={this.state.document.base64}
                            >
                            </iframe>
                            :
                            <iframe
                                title="dpdf1"
                                scrolling="no"
                                width="100%"
                                height="95%"
                                src={
                                    'https://docs.google.com/viewer?url=' +
                                    this.state.document.url + '&embedded=true'
                                }
                            >
                            </iframe>
                        )
                        : null}
                </Modal>
                <Scrollbars style={{ height: '100%', width: '100%' }}
                    renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{ display: "none" }} />}
                    renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{ display: "none" }} />}
                >
                    <button
                        style={{ marginBottom: 5 }}
                        onClick={() => this.props.dispatch(actions.addRow())}
                        className={"btn btn-primary waves-btn"}
                    >
                        Tilføj række
                    </button>
                    <Apvs
                        rows={this.props.apvs}
                        updateApv={this.updateApv}
                        update={this.update}
                        cancel={this.cancel}
                        save={this.save}
                        openPdf={this.openPdf}
                    />
                </Scrollbars>
            </div >
        );
    }
}

const styles = {
    container: {
        position: 'absolute',
        paddingTop: '80px',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        '@media (min-width: 1200px)': {
            left: '50%',
            marginLeft: '-585px',
            maxWidth: '1170px'
        }
    },
    apvCard: {
        height: 310,
        width: 350,
    }
}

const selectProps = state => {
    return {
        ...state.apvReducer
    };
}

export default connect(selectProps)(Radium(APV));


// WEBPACK FOOTER //
// ./src/App/APV/index.js